import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import { useTheme } from '../context/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import SocialFooter from '../components/SocialFooter';
import Help from './Help';

export default function HelpPage() {
  const { locale, toggleLocale, t } = useLocale();
  const { isDark, toggleDark } = useTheme();

  return (
    <div className="min-h-screen flex flex-col bg-[#fffbf0] dark:bg-slate-900 transition-colors duration-300">
      {/* 獨立導覽列 */}
      <nav className="bg-white/70 dark:bg-slate-900/80 backdrop-blur-lg sticky top-0 z-40 border-b border-gray-100 dark:border-slate-800 shadow-sm transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2 group hover:opacity-90 active:scale-95 transition-all focus:outline-none text-left">
              <div className="bg-gradient-to-br from-pink-400 to-rose-400 text-white p-2 rounded-xl shadow-sm rotate-3 group-hover:rotate-6 transition-transform">
                <SafeIcon name="ArrowLeft" className="w-5 h-5" />
              </div>
              <span className="font-black text-[1.1rem] sm:text-xl text-gray-800 dark:text-white tracking-wide">
                {t('nav.home')}
              </span>
            </Link>
            <div className="flex items-center gap-3 sm:gap-4">
              <button onClick={toggleLocale} className="w-9 h-9 rounded-full bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-slate-700 transition-all flex items-center justify-center font-bold text-sm" title={t('nav.toggleLang')}>
                {locale === 'zh-TW' ? 'EN' : '中'}
              </button>
              <button onClick={toggleDark} className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-yellow-400 hover:bg-gray-200 dark:hover:bg-slate-700 transition-all" title={t('nav.toggleTheme')}>
                {isDark ? <SafeIcon name="Moon" className="w-5 h-5" /> : <SafeIcon name="Sun" className="w-5 h-5" />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* 手繪風內容區 */}
      <main className="flex-1 w-full max-w-7xl mx-auto pt-6 sm:pt-10">
        <Help language={locale === 'zh-TW' ? 'zh' : 'en'} />
      </main>

      <SocialFooter />
    </div>
  );
}